var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { BaseInput } from '../../share/BaseInput';
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-miln6n-0"
})(["position:relative;"]);
export const RegularBase = _a => {
  var {
    isDisabled
  } = _a,
      rest = __rest(_a, ["isDisabled"]);

  return React.createElement(StyledContainer, null, React.createElement(BaseInput, Object.assign({
    isDisabled: isDisabled
  }, rest)));
};